let EVENT_TYPES = {
  appointment_bookings_state_update: 'AppointmentBookings',
  txs_status_update: 'TxStatus',
  custom_resource_insert: 'CustomResourceInsert',
}

export function getView(event_type) {
  return EVENT_TYPES[event_type] || 'No'
}
